import { Pipe, PipeTransform } from '@angular/core';
import { PlateNumber } from '../components/input-plate/types';

@Pipe({
  name: 'plate',
})
export class FormatPlatePipe implements PipeTransform {
  constructor() {}

  transform(input: any | PlateNumber): any {
    return input === null ||
      (((input as PlateNumber).plateStart === null || (input as PlateNumber).plateStart.length === 0) &&
        ((input as PlateNumber).plateEnd === null || (input as PlateNumber).plateEnd.length === 0))
      ? '-'
      : `${(input as PlateNumber).plateStart}${(input as PlateNumber).plateType.prefix}${
          (input as PlateNumber).plateEnd
        }`;
  }
}
